import { Container, FloatingLabel, Form } from 'react-bootstrap';
import { generalHelpers } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode, useGetIsMobile, useGetRecaptchaToken } from 'src/custom-hooks';
import { useNavigate } from 'react-router';
import { userServices } from 'src/services';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';

export const NewUserPage = () => {
    const [params] = useSearchParams();
    //
    const [confPassword, setConfPassword] = useState('')
    const [password, setPassword] = useState('')
    const dispatch = useDispatch()
    const email = params.get('email') || ''
    const getRecaptchaToken = useGetRecaptchaToken();
    const id = params.get('id') || ''  // invitationId
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const navigate = useNavigate();
    const team = params.get('team') || "0";

    const openAlertModalHandler = (title: string, message: string, animation?: number, execution?: Function): void => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'alert',
            title,
            message,
            animation,
            execution
        }));
    }

    const createAccountByEmailInvitationHandler = async () => {
        if (!id || !generalHelpers.IsValidEmail(email) || password.length < 8 || confPassword.length < 8 || password !== confPassword) {
            openAlertModalHandler("Faltan datos", '');
            return;
        }
        const congr = parseInt(team);
        if (isNaN(congr) || !Number.isInteger(congr)) {
            openAlertModalHandler("Hay un error en los datos", '');
            return;
        }
        const recaptchaToken = await getRecaptchaToken();
        if (!recaptchaToken) {
            openAlertModalHandler("Problemas (1)", "Refrescar la página", 2);
            return;
        }
        dispatch(showLoadingModalReducer());
        const response = await userServices.Register(congr, email, id, password, recaptchaToken);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        openAlertModalHandler("Usuario creado con éxito", '', 1, () => navigate('/'));
    }

    return (
        <Container className={'maxw-400'}>
            <h2 className={`text-center mt-5 mx-auto ${isDarkMode ? 'text-white' : ''}`}
                style={{
                    fontSize: isMobile ? '1.7rem' : '2rem',
                    maxWidth: '90%',
                    textShadow: '0 0 1px gray'
                }}
            >
                COMPLETAR PARA CREAR UN USUARIO
            </h2>
            <Container style={{ maxWidth: '500px', padding: isMobile ? '35px 30px 0' : '35px 0 0' }}>
                <FloatingLabel className={'mb-3 text-dark'}
                    label={"Correo electrónico"}
                >
                    <Form.Control type={'email'}
                        className={'form-control'}
                        placeholder={''}
                        value={email}
                        onChange={() => {}}
                        disabled
                    />
                </FloatingLabel>
                <FloatingLabel className={'mb-3 text-dark'}
                    label={"Nueva Contraseña"}
                >
                    <Form.Control type={'password'}
                        className={'form-control'}
                        placeholder={''}
                        value={password}
                        onChange={e => setPassword((e.target as HTMLInputElement).value)}
                        autoFocus
                    />
                </FloatingLabel>
                <FloatingLabel className={'mb-3 text-dark'}
                    label={"Confirmar Nueva Contraseña"}
                >
                    <Form.Control type={'password'}
                        className={'form-control'}
                        placeholder={''}
                        value={confPassword}
                        onChange={e => setConfPassword((e.target as HTMLInputElement).value)}
                        onKeyDown={e => e.key === 'Enter' && !(!generalHelpers.IsValidEmail(email) || password.length < 8 || confPassword.length < 8 || password !== confPassword) ? createAccountByEmailInvitationHandler() : null }
                    />
                </FloatingLabel>
                {/* <FloatingLabel
                    label={"Número de Grupo"}
                    className={'mb-3 text-dark'}
                >
                    <Form.Control
                        type={'number'}
                        className={'form-control'}
                        placeholder={''}
                        value={group ? group : ''}
                        min={'1'}
                        onChange={e => setGroup(parseInt(e.target.value))}
                        onKeyDown={e => e.key === 'Enter' && !(!emailPattern.test(email) || password.length < 8 || confPassword.length < 8 || password !== confPassword || !group) ? createAccountByEmailInvitationHandler() : null }
                    />
                </FloatingLabel> */}
                <button className={'btn btn-general-blue d-block w-100 mt-5'}
                    style={{ fontWeight: 'bolder', height: '50px' }}
                    onClick={createAccountByEmailInvitationHandler}
                    disabled={!generalHelpers.IsValidEmail(email) || password.length < 8 || confPassword.length < 8 || password !== confPassword}
                >
                    CREAR USUARIO
                </button>
                <button
                    className={`btn btn-general-red d-block w-100 mt-4 mb-5`}
                    style={{ fontWeight: 'bolder', height: '50px' }}
                    onClick={() => navigate('/')}
                >
                    CANCELAR
                </button>
            </Container>
        </Container>
    );
}
